import { useAuthStore } from '../store/authStore'

/**
 * Returns a callback that either returns the target URL (if logged in)
 * or a React login URL with the target as returnUrl (if logged out).
 *
 * Use this for recurring subscription actions that require authentication.
 */
export function useRequireAuth() {
  const user = useAuthStore((state) => state.user)

  return (targetUrl) => {
    if (user) return targetUrl
    return `/login?returnUrl=${encodeURIComponent(targetUrl)}`
  }
}
